import { LgQuery } from "lightgallery/lgQuery";
import { LightGallery } from "lightgallery/lightgallery";

// This plugin is a hack to get the thumbnail to show up for HTML5 videos.
// Requires the lg-thumbnail plugin to be loaded first.
export default class HTML5VideoThumbnail {
  core: LightGallery;
  private $LG: LgQuery;
  constructor(instance: LightGallery, $LG: LgQuery) {
    this.core = instance;
    this.$LG = $LG;
  }

  init() {
    this.core.LGel.on("lgBeforeOpen", this.onBeforeOpen.bind(this));
  }

  onBeforeOpen() {
    const thumbnails: Element[] = [];
    // Find the container that holds the thumbnails and is visible
    const visibleContainer = this.$LG(".lg-container.lg-show").get();
    this.core.galleryItems.forEach((item, i) => {
      if ("video" in item && item.video) {
        const thumbnail = visibleContainer.querySelector(`.lg-thumb-item[data-lg-item-id="${i}"]`)!;
        thumbnails.push(thumbnail);
      }
    });

    // Replace the <img> tag with the <video> tag
    thumbnails.forEach((thumbnail) => {
      // Check if the thumbnail already has a video tag
      if (thumbnail.querySelector("video")) {
        return;
      }

      const itemIndex = parseInt(thumbnail.getAttribute("data-lg-item-id")!);
      const item = this.core.galleryItems[itemIndex];
      const img = thumbnail.querySelector("img");
      // Remove the <img> tag
      img?.remove();
      // Add the <video> tag inside the thumbnail
      const video = document.createElement("video");
      video.src = item.downloadUrl as string;
      video.controls = false;
      video.muted = true;
      // add the item index to the video tag
      video.setAttribute("data-lg-item-id", itemIndex.toString());

      // Set a custom attribute to the thumbnail so we can find it later
      thumbnail.setAttribute("data-lg-html5-video-thumbnail", "true");

      // Change the video tag width and height to match the thumbnail
      const thumbnailWidth = thumbnail.clientWidth;
      const thumbnailHeight = thumbnail.clientHeight;
      // Add them to the video tag style
      video.style.width = `${thumbnailWidth}px`;
      video.style.height = `${thumbnailHeight}px`;
      thumbnail.appendChild(video);

      // Play badge matching the grid's AssetPreview overlay (a dark circle behind the white `play`
      // icon). Reuses the same SVG paths as the `play` icon in Icon.tsx so the look stays in sync;
      // inlined here because this plugin runs outside React.
      (thumbnail as HTMLElement).style.position = "relative";
      const badge = document.createElement("div");
      badge.style.cssText =
        "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:rgba(0,0,0,0.45);pointer-events:none;";
      badge.innerHTML =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z"/>' +
        '<path d="M9.5 8L16 12L9.5 16V8Z"/></svg>';
      thumbnail.appendChild(badge);
    });
  }

  destroy() {
    // Unbind all events added by the plugin
    this.core.LGel.off("lgBeforeOpen");
  }
}
